<template>
    <div>
        <rkm-area
            background-color="success"
            header-prefix-text="P"
            title="Plano - Evolução"
            type="box"
        >
            <template v-if="!data.additionals.isAtendimentoSaudeBucal">
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-text-editor
                            :validations="validations.descricao"
                            name="Descrição"
                            placeholder="Insira informações adicionais sobre o plano de cuidado."
                            v-model="data.model.descricao"
                        />
                    </rkm-col>
                </rkm-row>

                <BoxIntervencao
                    :data="data"
                    class="mt-3"
                />
            </template>

            <BoxProcedimentoClinico :data="data" />
            <BoxProcedimentoFerida
                v-if="data.additionals.tipoAgendamentoSafecare"
                :data="data"
            />
            <BoxProcedimentoEmad
                v-if="data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar"
                :data="data"
            />

            <rkm-tabs
                v-if="data.additionals.isAtendimentoSaudeBucal"
                class="mt-2"
            >
                <rkm-tab title="Odontograma">
                    <BoxOdontograma :data="data" />
                </rkm-tab>
            </rkm-tabs>

            <rkm-tabs class="mt-2">
                <rkm-tab title="Prescrição de medicamentos">
                    <BoxPrescricaoMedicamento :data="data" />
                </rkm-tab>

                <rkm-tab title="Solicitação de exames">
                    <BoxSolicitacaoExame :data="data" />
                </rkm-tab>

                <rkm-tab title="Solicitação de procedimentos cirúrgicos">
                    <BoxSolicitacaoProcedimentoCirurgico :data="data" />
                </rkm-tab>

                <rkm-tab title="Testes rápidos">
                    <BoxTesteRapido :data="data" />
                </rkm-tab>

                <rkm-tab title="Atestados">
                    <BoxAtestado :data="data" />
                </rkm-tab>

                <rkm-tab title="Declarações de comparecimento">
                    <BoxDeclaracaoComparecimento :data="data" />
                </rkm-tab>

                <rkm-tab title="Cartas médicas">
                    <BoxCartaMedica :data="data" />
                </rkm-tab>

                <rkm-tab title="Orientações">
                    <BoxOrientacao :data="data" />
                </rkm-tab>

                <rkm-tab title="Encaminhamentos">
                    <BoxEncaminhamento :data="data" />
                </rkm-tab>

                <rkm-tab title="Compartilhamento de cuidado">
                    <BoxCompartilhamentoCuidado :data="data" />
                </rkm-tab>
            </rkm-tabs>
        </rkm-area>
    </div>
</template>

<script>
// Components.
import BoxAtestado from './components/atestado/Index'
import BoxCartaMedica from './components/carta-medica/Index'
import BoxCompartilhamentoCuidado from './components/compartilhamento-cuidado/Index'
import BoxDeclaracaoComparecimento from './components/declaracao-comparecimento/Index'
import BoxEncaminhamento from './components/encaminhamento/Index'
import BoxIntervencao from './components/intervencao/Index'
import BoxOdontograma from './components/odontograma/Index'
import BoxOrientacao from './components/orientacao/Index'
import BoxPrescricaoMedicamento from './components/prescricao-medicamento/Index'
import BoxProcedimentoClinico from './components/procedimento-clinico/Index'
import BoxProcedimentoFerida from './components/procedimento-ferida/Index'
import BoxProcedimentoEmad from './components/procedimento-emad/Index'
import BoxSolicitacaoExame from './components/solicitacao-exame/Index'
import BoxSolicitacaoProcedimentoCirurgico from './components/solicitacao-procedimento-cirurgico/Index'
import BoxTesteRapido from './components/teste-rapido/Index'

export default {
    components: {
        BoxAtestado,
        BoxCartaMedica,
        BoxCompartilhamentoCuidado,
        BoxDeclaracaoComparecimento,
        BoxEncaminhamento,
        BoxIntervencao,
        BoxOdontograma,
        BoxOrientacao,
        BoxPrescricaoMedicamento,
        BoxProcedimentoClinico,
        BoxProcedimentoFerida,
        BoxProcedimentoEmad,
        BoxSolicitacaoExame,
        BoxSolicitacaoProcedimentoCirurgico,
        BoxTesteRapido,
    },
    computed: {
        validations() {
            return {
                descricao: {max: 5000},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>